import React, { ReactNode, useEffect, useRef } from 'react'
import { Heading, Icon } from '@msaf/core-react'

export interface MapContextContentProps {
  heading?: string
  headingIcon?: ReactNode
  headingAction?: ReactNode
  panelContent?: ReactNode
  scrollToTopOnContentChange?: boolean
}

export interface MapContextPanelContentProps extends MapContextContentProps {
  closePanel: () => void
}

export function MapContextPanelContent({
  heading,
  headingIcon,
  headingAction,
  closePanel,
  panelContent,
  scrollToTopOnContentChange = true,
}: MapContextPanelContentProps) {
  const contentRef = useRef<HTMLDivElement>(null)
  useEffect(() => {
    if (scrollToTopOnContentChange) {
      contentRef.current?.scrollTo(0, 0)
    }
  }, [panelContent, scrollToTopOnContentChange])

  return (
    <>
      <div className='c-map-context-panel__header'>
        <div className='c-map-context-panel__heading-content' ref={contentRef}>
          {headingIcon && <div className='c-map-context-panel__heading-icon'>{headingIcon}</div>}
          <div className='c-map-context-panel__header-actions'>
            {headingAction}
            <button className='c-map-context-panel__close-btn' onClick={() => closePanel()}>
              <Icon icon='close' ariaLabel='Close menu panel' />
            </button>
          </div>
        </div>
        <div className='c-map-context-panel__heading-content'>
          <Heading level={2} className='c-map-context-panel__heading'>
            {heading}
          </Heading>
        </div>
      </div>
      <div className='c-map-context-panel__content'>{panelContent}</div>
    </>
  )
}
